import { getAgreement } from 'publisher/api/agreementApi'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import usePage from 'publisher/hooks/usePage'
import { selectors as pageSelectors } from 'publisher/reducers/pageReducer'
import React, { useEffect, useState } from 'react'
import { CommonAgreement } from 'src/shared/components/agreement'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'

interface AgreementProps {
  entity: AgreementInterface
}

export function Agreement({ entity }: AgreementProps) {
  const pageId = usePage(pageSelectors.getPageId)

  const [agreementText, setAgreementText] = useState<string>('')

  useEffect(() => {
    getAgreement(pageId).then(res => {
      // remove escape characters
      const sanitizedText = res.data.replace(/\\"/g, '"')
      setAgreementText(sanitizedText)
    })
  }, [pageId])

  if (!agreementText) {
    return null
  }

  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonAgreement id={entity.htmlAttrId} text={agreementText} />
    </StyleWrapper>
  )
}
